import _ from 'lodash';

export default function isNewExperienceEnabled(
  { new_experience_visible: newExperienceVisible = null },
  region,
) {
  try {
    const newExperienceVisibleByRegion =
      newExperienceVisible !== null
        ? JSON.parse(newExperienceVisible)
        : {
            default: { enabled: false },
            mexico: { enabled: true },
          };
    return _.get(newExperienceVisibleByRegion, [region, 'enabled'], false);
  } catch (error) {
    return false;
  }
}

export function isNewExperienceEnabledWNTranslations(region) {
  try {
    const defaultObj = {
      default: { enabled: false },
      mexico: { enabled: true },
    };
    const newExperienceVisible = window.utils.getMeta.metadata(
      'new_experience_visible',
      defaultObj,
    );
    return newExperienceVisible[region].enabled || false;
  } catch (error) {
    return false;
  }
}
